
define('core/node_fs_stats',["require", "exports"], function(require, exports) {
    (function (FileType) {
        FileType[FileType["FILE"] = 0x8000] = "FILE";
        FileType[FileType["DIRECTORY"] = 0x4000] = "DIRECTORY";
        FileType[FileType["SYMLINK"] = 0xA000] = "SYMLINK";
    })(exports.FileType || (exports.FileType = {}));
    var FileType = exports.FileType;

    var Stats = (function () {
        function Stats(item_type, size, mode, atime, mtime, ctime) {
            if (typeof atime === "undefined") { atime = new Date(); }
            if (typeof mtime === "undefined") { mtime = new Date(); }
            if (typeof ctime === "undefined") { ctime = new Date(); }
            this.size = size;
            this.mode = mode;
            this.atime = atime;
            this.mtime = mtime;
            this.ctime = ctime;
            this.dev = 0;
            this.ino = 0;
            this.rdev = 0;
            this.nlink = 1;
            this.blksize = 4096;
            this.uid = 0;
            this.gid = 0;
            if (this.mode == null) {
                switch (item_type) {
                    case 32768 /* FILE */:
                        this.mode = 0x1a4;
                        break;
                    case 16384 /* DIRECTORY */:
                    default:
                        this.mode = 0x1ff;
                }
            }

            this.blocks = Math.ceil(size / 512);
            this.mode |= item_type;
        }
        Stats.prototype.clone = function () {
            return new Stats(this.mode & 0xF000, this.size, this.mode & 0xFFF, this.atime, this.mtime, this.ctime);
        };

        Stats.prototype.isFile = function () {
            return (this.mode & 0xF000) === 32768 /* FILE */;
        };

        Stats.prototype.isDirectory = function () {
            return (this.mode & 0xF000) === 16384 /* DIRECTORY */;
        };

        Stats.prototype.isSymbolicLink = function () {
            return (this.mode & 0xF000) === 40960 /* SYMLINK */;
        };

        Stats.prototype.chmod = function (mode) {
            this.mode = (this.mode & 0xF000) | mode;
        };

        Stats.prototype.isSocket = function () {
            return false;
        };

        Stats.prototype.isBlockDevice = function () {
            return false;
        };

        Stats.prototype.isCharacterDevice = function () {
            return false;
        };

        Stats.prototype.isFIFO = function () {
            return false;
        };
        return Stats;
    })();
    exports.Stats = Stats;
});
//# sourceMappingURL=node_fs_stats.js.map
;